// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q5YC","type":"styles_type__1uW89","choices":"styles_choices__3h69w"};